export function downloadTourismContract(id) {
    return axios({
        url: `/api/test/insurance/tourism/contract/take`,
        method: 'post',
        data: {
            contractId: id,
        },
    });
}
